import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react-pro';
import React from 'react';
import styles from './styles';

const OTPModal = ({
    msg,
    otp,
    setOtp,
    handleCloseTnC
}) => {
    return (
        <div>
            <CModal
                fullscreen={"md"}
                backdrop="static"
                alignment="center"
                size={'lg'}
                visible={true}
                // onClose={() => setShowValidationForm(false)}
                aria-labelledby="StaticBackdropExampleLabel"
            >
                <CModalHeader closeButton={false}>
                    <CModalTitle id='StaticBackdropExampleLabel'>Verify OTP</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div>
                        <p>{msg}</p>
                    </div>
                    <div className="d-flex justify-content-center gap-2">
                        {[...Array(4)].map((_, idx) => (
                            <input
                                key={idx}
                                type="text"
                                maxLength={1}
                                style={styles?.optInputField}
                                value={otp?.[idx] || ''}
                                onChange={e => {
                                    const val = e.target.value.replace(/[^0-9]/g, '');
                                    let newOtp = otp ? [...otp] : Array(4).fill('');
                                    newOtp[idx] = val;
                                    setOtp(newOtp);
                                    // Move to next input if value entered
                                    if (val && idx < 5) {
                                        document.getElementById(`otp-input-${idx + 1}`)?.focus();
                                    }
                                }}
                                onKeyDown={e => {
                                    if (e.key === 'Backspace' && !otp?.[idx] && idx > 0) {
                                        document.getElementById(`otp-input-${idx - 1}`)?.focus();
                                    }
                                }}
                                id={`otp-input-${idx}`}
                                autoComplete="off"
                            />
                        ))}
                    </div>
                </CModalBody>
                <CModalFooter>
                    <div className='d-flex w-100 justify-content-md-end align-items-center'>
                        <CButton
                            color="primary"
                            onClick={handleCloseTnC}
                        >
                            Done
                        </CButton>
                    </div>
                </CModalFooter>
            </CModal>
        </div>
    )
}

export default OTPModal